const isDev = process.env.NODE_ENV === 'development';
const BASE = isDev ? '' : (process.env.REACT_APP_API_BASE_URL || '');

const getAuthHeaders = () => {
    const user = process.env.REACT_APP_API_USER;
    const pass = process.env.REACT_APP_API_PASSWORD;
    if (!user || !pass) return {};
    const token = btoa(`${user}:${pass}`);
    return { 'Authorization': `Basic ${token}` };
};

export const getActivePromo = async () => {
    try {
        // Get all promos and find the active one
        const promos = await getAllPromos();
        const now = new Date();

        // Find a promo that is currently active (within date range)
        const activePromo = promos.find(promo => {
            const start = new Date(promo.startDate + 'T00:00:00');
            const end = new Date(promo.endDate + 'T23:59:59');
            return now >= start && now <= end;
        });

        return activePromo || null;
    } catch (error) {
        console.error('Error fetching active promo:', error);
        return null;
    }
};

export const getAllPromos = async () => {
    try {
        const response = await fetch(`${BASE}/api/promotionalConfigs`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) throw new Error('Failed to fetch promos');
        return await response.json();
    } catch (error) {
        console.error('Error fetching promos:', error);
        return [];
    }
};

export const createPromo = async (promoData) => {
    try {
        const response = await fetch(`${BASE}/api/promotionalConfigs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(promoData)
        });
        if (!response.ok) throw new Error('Failed to create promo');

        // Backend returns void, so just return success
        return { success: true };
    } catch (error) {
        console.error('Error creating promo:', error);
        throw error;
    }
};

export const updatePromo = async (id, promoData) => {
    try {
        const response = await fetch(`${BASE}/api/promotionalConfigs/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...getAuthHeaders()
            },
            body: JSON.stringify(promoData)
        });
        if (!response.ok) throw new Error('Failed to update promo');

        // Backend returns void, so just return success
        return { success: true };
    } catch (error) {
        console.error('Error updating promo:', error);
        throw error;
    }
};

export const deletePromo = async (id) => {
    try {
        const response = await fetch(`${BASE}/api/promotionalConfigs/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!response.ok) throw new Error('Failed to delete promo');
        return true;
    } catch (error) {
        console.error('Error deleting promo:', error);
        throw error;
    }
};
